import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'testFilter'})
export class TestFilterPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!value || !args) {
      return value;
    }
    // return null;
    return value.filter(item => item.name == args.name);
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/core/pipe/test-filter.pipe.ts